import React, {Component, PropTypes} from 'react';
import styled from 'styled-components';
import {
  Col,
} from '@sketchpixy/rubix';
import {
  getPaymentDetail,
} from '../../../api/api';
import NumberFormat from "react-number-format";
import moment from "moment";

const Root = styled(Col)`
  padding: 0;
`;


const Container = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: ${props => props.expand ? '2px' : '1px'} solid #d8d8d8;

`;

const Title = styled.div`
  height: 65px;
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
  font-size: 18px;
`;

const Item = styled.div`
  display: flex;
  min-height: 60px;
  text-align: justify;
   
  &:last-child {
    border-bottom: 0;
  }
  
  & div:first-child {
    color: black;
  }
  
  & div {
    margin-top: auto;
    margin-bottom: auto;
    padding: 0;
  }
`;

const ItemTitle = styled.div`
  width: 202px;
  font-size: 16px;
`;


class ArInfo extends Component {
  constructor(props) {
    super(props);

    let opportunityLink = props.contract.opportunityLink ? props.contract.opportunityLink : '';
    this.state = {
      payment: {},
      payPeriod: 1,
      opportunityLink: opportunityLink
    };
  }


  componentDidMount() {
    this.getPaymentDetail();
  }

  displayAmount = (amount) => {
    const scientificNotation = Math.pow(10, this.props.decimalScale * -1);
    return (amount * scientificNotation).toFixed(2);
  };



  getPaymentDetail() {
    getPaymentDetail(this.props.contract.contractId, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        const payment = result.detail;
        this.setState({
          payment,
          nextPaymentDate: payment.nextPaymentDate
        });

      }
    });
  }


  render() {
    let latestPaidDate = moment(this.state.payment.latestPaidDate).format('YYYY-MM-DD');

    return (
        <Root xs={12}>
          <Title>AR Info</Title>
          <Container>
            {
              this.props.contract.contractPgBillingKey &&
              <Item>
                <ItemTitle>Stripe Link</ItemTitle>
                <ItemTitle>
                  <a href={"https://dashboard.stripe.com/search?query="+this.props.contract.contractPgBillingKey}>{this.props.contract.contractPgBillingKey}</a>
                </ItemTitle>
              </Item>
            }
            {
              this.props.contract.opportunityId &&
              <Item>
                <ItemTitle>SFDC link </ItemTitle>
                <ItemTitle>
                  <a href={"https://neofect.lightning.force.com/lightning/r/Opportunity/" + this.props.contract.opportunityId + "/view"}>{this.props.contract.opportunityId}</a>
                </ItemTitle>
              </Item>
            }
            <Item>
              <ItemTitle>Latest Paid Date</ItemTitle>
              <div>{latestPaidDate}</div>
            </Item>
            <Item>
              <ItemTitle>Days Since Unpaid</ItemTitle>
              <div>{this.state.payment.daySinceFailed}</div>
            </Item>
            <Item>
              <ItemTitle>Payment Status</ItemTitle>
              <div>{this.state.payment.paymentStatus}</div>
            </Item>
          </Container>
        </Root>
    );
  }
}

ArInfo.propTypes = {
  contract: PropTypes.shape({
    contractId: PropTypes.number,
    currencyName: PropTypes.string,
    currencyCode: PropTypes.string,
    currencyString: PropTypes.string,
    contractSalesRepEmail: PropTypes.string,
    contractPatientEmail: PropTypes.string,
    contractPgType: PropTypes.string,
    contractPgBillingKey: PropTypes.string,
    contractDevicesDetail: PropTypes.string,
    contractBillingDate: PropTypes.number,
    nextPaymentDate: PropTypes.string,
    contractStatus: PropTypes.string,
    installmentPeriod: PropTypes.number,
    contractOnetimeAmount: PropTypes.number,
    contractHardwareAmount: PropTypes.number,
    contractPostalCode: PropTypes.string,
    contractTaxRate: PropTypes.number,
    patientSubscription: PropTypes.object,
    payments: PropTypes.array,
    schedule: PropTypes.object,
    opportunityId: PropTypes.string,
    createdTime: PropTypes.number,
    updatedTime: PropTypes.number,
  }).isRequired,
};


export default ArInfo;



// WEBPACK FOOTER //
// ./src/routes/patient/PaymentInfo/ArInfo.js